/*
 * LPO's sign fields, worded for the new theme (owner 2026-10-08). DISPLAY ONLY.
 *
 * The labels are LPO app settings, shared with the live theme, and they vary
 * per product ("Font Select", "Add Text", "Add inscription", "1st Row"...).
 * Each LPO option keeps its NAME apart from its LABEL: the name is
 * div.cl-po--option[data-option] and the inputs' properties[...] key, which is
 * what production reads ("Choose Initial"), while the label is only the text
 * the customer sees ("Choose your Initial"). So this rewrites the visible
 * label text, swaps the generic "YOUR TEXT HERE" placeholder, and marks text
 * fields with their own maxlength for the "Up to N characters" hint
 * (sis-skin.css draws it from data-sis-limit). Names, values and inputs are
 * never touched.
 *
 * Markup relied on (captured live 2026-10-08, signs):
 *   div.cl-po--option[data-option] > div.cl-po--label (text node + Vue
 *   comment anchors), input.cl-po--input[type=text][maxlength]
 * LPO re-renders its fields (variant change, conditional fields), so a
 * MutationObserver re-applies. If LPO changes its markup this silently does
 * nothing and LPO's own wording shows.
 */
(() => {
  const tag = document.getElementById('sis-lpo-labels');
  const hint = (tag && tag.dataset.limitHint) || 'Up to [count] characters';
  const LABELS = new Map([
    ['font select', 'Font'],
    ['add text', 'Your text'],
    ['add your text', 'Your text'],
    ['add inscription', 'Your text'],
    ['custom text (optional)', 'Your text (optional)'],
    ['choose your initial', 'Initial'],
    ['add names', 'Names'],
    ['add 2nd row?', 'Add a second line?'],
    ['1st row', 'Line 1'],
    ['2nd row', 'Line 2'],
    ['3rd row', 'Line 3'],
    ['4th row', 'Line 4'],
  ]);
  const GENERIC_PLACEHOLDER = /^your text here$/i;
  const PLACEHOLDER = 'Type your text';

  function tidy(root) {
    root.querySelectorAll('.cl-po--label').forEach((label) => {
      label.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const next = LABELS.get(node.textContent.trim().toLowerCase());
        if (next && node.textContent.trim() !== next) node.textContent = ` ${next} `;
      });
    });
    root.querySelectorAll('.cl-po--option input.cl-po--input[type="text"]').forEach((input) => {
      if (GENERIC_PLACEHOLDER.test(input.placeholder.trim())) input.placeholder = PLACEHOLDER;
      const option = input.closest('.cl-po--option');
      const text = hint.replace('[count]', String(input.maxLength));
      if (option && input.maxLength > 0 && option.dataset.sisLimit !== text) option.dataset.sisLimit = text;
    });
  }

  function attach() {
    const root = document.querySelector('.cl-po--wrapper');
    if (!root) return false;
    tidy(root);
    // attributes too: LPO swaps placeholder/maxlength when a field re-renders
    new MutationObserver(() => tidy(root)).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'maxlength'],
    });
    return true;
  }

  if (attach()) return;
  // LPO mounts after load; stop looking after 20 s on a page without it.
  const wait = new MutationObserver(() => {
    if (attach()) wait.disconnect();
  });
  wait.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => wait.disconnect(), 20000);
})();
